/**
 * created by tian ruo jun
 选择栏目及同步发布其他栏目
 *
 */
import React, {Component} from 'react';
import {Icon, Input, Tree, DatePicker, Select, message} from 'antd'
import SwitchBounced from "../../components/switchBounced/SwitchBounced"
import '../EditorPublishInformation.css'
import Concurrently from "../concurrently/Concurrently";
import BaseComponent from "../../../../base/BaseComponent";

const {TreeNode} = Tree;
const {Option} = Select;
const publishSettings = {
//栏目信息
    programaKey: 'programaFtitle',//栏目信息数据保存标题key
    programaName: '栏目',//栏目信息标题名称
//当前栏目信息
    currentColumnKey: 'currentColumnFtitle',//当前栏目信息数据保存标题key
    currentColumnName: '当前栏目',//当前栏目信息标题名称
    headlinesPlaceholder: '这是一个栏目名称',//栏目名称的提示
    currentColumnIsRequest: true,//是否必输项，
    currentColumnCheckMessage: '请选择当前栏目',
};

export default class SelectColumn extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meanWhile: false,
            synchronize: true,
            contribute:true,
            properties: true,
            orso: true,
            switchShow: false,
            publishInformation: {
                currentColumn: [],//当前栏目
                numerical: '',//重要性
                location: '',//显示位置
                frequency: '',//点击次数
                accretion: [],//同步数据
            },
            // 栏目数
            columnTree: [],
        }
    }

    componentWillMount() {
        this.getColumnTree();
    }

    componentDidMount() {}

    // 获取栏目树
    getColumnTree = () => {
        this.request({
            url:"/cm-sites-pms/website/getColumnTree",
            body: {"mediaId":"62551a71c06a0e6a0e96be380"},
            callBack: (res) => {
                let columnTree = [];
                if (res) {
                    columnTree = [res];
                }
                this.setState({columnTree})
            },
            errorCallBack: (e) => {
                this.setState({columnTree: []})
            }
        })
    }

    renderTab = () => {
        const {publishInformation, orso} = this.state;
        return (
            <div className="sectionArrow">
                <div className="overstriking">{publishSettings.programaName}</div>
                <div><Icon className="lineIcon" type={orso ? "down" : "up"} onClick={this.arrowTransform}/>
                </div>
            </div>
        )
    }

    renderPresentColumn = () => {
        const {publishInformation, orso} = this.state;
        return (
            <>
            {orso ?
                    <div className="currentColumn">
                        <div className="currentColumnText">{publishSettings.currentColumnName}</div>
                        <Input className="currentColumnInput" value={publishInformation.currentColumn}
                               placeholder={publishSettings.headlinesPlaceholder}
                               onClick={this.showModal}
                        />
                        <div className="cut" onClick={this.showModal}>切换</div>
                        <SwitchBounced handleOk={data => this.handleOk(data)}
                                       handleCancel={() => this.handleCancel()}
                                       switchShow={this.state.switchShow}/>
                    </div> : null
            }
            </>
        )
    }

    renderConcurrentColumn = () => {
        const {publishInformation, orso, columnTree} = this.state;
        const {accretion=[]} = publishInformation;
        const concurrentColumnLength = accretion.length || 0;

        return (
            <>
                <div className="simultaneous">
                    <div className="synchronizationStyle">同时发布到({concurrentColumnLength})</div>
                    <div><Icon className="simultaneousIcon" type="plus" onClick={this.simultaneously}/></div>
                    <Concurrently
                        meanWhile={this.state.meanWhile}
                        handleOk={data => this.simulhandleOk(data)}
                        handleCancel={() => this.simulhandleCancel()}
                        treeData={columnTree}
                    ></Concurrently>
                </div>
                <div className="release">
                    {concurrentColumnLength ? accretion.map((item, index) => {
                        return (
                            <div key={index} className="releaseTo">
                                <div className="set">
                                    <div><Icon className="simultaneousFile" type="file-text"/></div>
                                    <div>{item}</div>
                                </div>
                                <div className="setText">设置</div>
                            </div>
                        )
                    }) : ''}
                </div>
            </>
        )
    }

    render() {
        return (
            <>
                {/*tab*/}
                {this.renderTab()}
                {/*当前栏目*/}
                {this.renderPresentColumn()}
                {/*同时发布栏目*/}
                {this.renderConcurrentColumn()}
            </>
        )
    }

    arrowTransform = () => {
        const {orso} = this.state
        this.setState({
            orso: !orso,
        })
    }

    showModal = () => {
        this.setState({
            switchShow: true,
        });
    };

    handleOk = (data) => {

        const {publishInformation} = this.state
        this.setState({
            publishInformation: {...publishInformation, currentColumn: data}
        }, () => {

        });
        this.handleCancel()
    }

    handleCancel = () => {
        this.setState({
            switchShow: false,
        });
    }

    simultaneously = () => {
        this.setState({
            meanWhile: true,
        });
    };

    simulhandleOk = (data) => {

        const {publishInformation} = this.state
        console.log(data)
        // data.forEach(item=>{
        this.setState({
            publishInformation: {...publishInformation, accretion: data}
        })
        // })

        this.simulhandleCancel()
    }

    simulhandleCancel = () => {
        this.setState({
            meanWhile: false,
        });
    }
}
